export default __webpack_public_path__ + "static/20922-Menu-PA-100-9f177d7eb09bc6269d090abb91cd04d9.jpg";